export default "/images/vendor/quill/icons/underline.svg?585c47324c8f9d8c076d8d7bb452efaa";